type Translate = (key: string, options?: Record<string, unknown>) => string;

/** Local calendar day, e.g. "2026-10-24". Used to group messages by day. */
export const getDayKey = (isoDate: string): string => {
  const date = new Date(isoDate);
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
};

/** "Today", "Yesterday" or a long localized date for the day divider. */
export const formatDayLabel = (
  isoDate: string,
  lang: string,
  t: Translate,
  now: Date = new Date(),
): string => {
  const key = getDayKey(isoDate);
  if (key === getDayKey(now.toISOString())) return t("today");

  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (key === getDayKey(yesterday.toISOString())) return t("yesterday");

  try {
    return new Intl.DateTimeFormat(lang, {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    }).format(new Date(isoDate));
  } catch {
    return new Date(isoDate).toDateString();
  }
};
